import React from 'react';

const IndieGameSkeleton = () => {
  return (
    <div className="card skeleton-card">
      <div className="card-body-content">
        {/* Media Section Skeleton */}
        <div className="card-media-grid">
          <div className="card-media-item">
            <div className="skeleton skeleton-media"></div>
          </div>
        </div>

        {/* Title and Description Skeleton */}
        <div style={{ marginBottom: '16px' }}>
          <div className="skeleton skeleton-title" style={{ marginBottom: '12px' }}></div>
          <div className="skeleton skeleton-text" style={{ marginBottom: '8px' }}></div>
          <div className="skeleton skeleton-text" style={{ width: '90%', marginBottom: '8px' }}></div>
          <div className="skeleton skeleton-text" style={{ width: '70%' }}></div>
        </div>

        {/* Price Section Skeleton */}
        <div style={{
          background: 'var(--card-bg-secondary)',
          padding: '16px',
          borderRadius: '8px',
          border: '1px solid var(--border-color)',
          marginBottom: '16px'
        }}>
          <div className="skeleton skeleton-small-text" style={{ marginBottom: '8px', width: '30%' }}></div>
          <div className="skeleton skeleton-price"></div>
        </div>

        {/* Store Links Section Skeleton */}
        <div style={{ marginBottom: '16px' }}>
          <div className="skeleton skeleton-heading" style={{ marginBottom: '12px', width: '40%' }}></div>
          <div className="card-links">
            <div className="skeleton skeleton-badge"></div>
            <div className="skeleton skeleton-badge"></div>
          </div>
        </div>

        {/* Rating Section Skeleton */}
        <div style={{ marginBottom: '16px' }}>
          <div className="skeleton skeleton-stars" style={{ width: '50%' }}></div>
        </div>

        {/* Buttons Section Skeleton */}
        <div style={{ display: 'flex', gap: '12px' }}>
          <div className="skeleton skeleton-button"></div>
          <div className="skeleton skeleton-button"></div>
        </div>
      </div>
    </div>
  );
};

export default IndieGameSkeleton;
